var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"contextmenu-wrap",class:'contextmenuName-' + _vm.contextMenuData.menuName},_vm._l((_vm.menulist),function(item){return _c('li',{key:item.name,staticClass:"menu-list"},[_c('button',{on:{"click":function($event){$event.stopPropagation();return _vm.handler(item)}}},[_c('span',[_vm._v(_vm._s(item.name))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }